import { useTranslation } from 'react-i18next'

import Tag, { type TagColor } from '@/components/Tag/Tag'

import type { CurriculumTimeUnit } from '../constants/curriculum-time-unit'

const TIME_UNIT_TAG_COLOR_MAP: Record<CurriculumTimeUnit, TagColor> = {
  semester: 'violet',
  week: 'orange',
  year: 'green'
}

type CurriculumTimeUnitTagProps = {
  timeUnit: CurriculumTimeUnit
}

const CurriculumTimeUnitTag = (props: CurriculumTimeUnitTagProps) => {
  const { t } = useTranslation('curriculumsManagement')

  return (
    <Tag
      color={TIME_UNIT_TAG_COLOR_MAP[props.timeUnit]}
      label={t(`time-unit.${props.timeUnit}`)}
      variant="with-background"
    />
  )
}

export default CurriculumTimeUnitTag
